<template lang="pug">
  v-menu(
    v-model="visible"
  )
    template(v-slot:activator="{ on, attrs }")
      div(style="position:relative;")
        .pa-3(
          v-on="on"
          v-bind="attrs"
          style="position:absolute; z-index:3; width:100%; height:100%;"
        ) 
        text-field-base(
          dense
          outlined
          readonly
          :label="label"
          :value="textDisplay"
          style="border-radius:10px; min-height:20px;" 
          :placeholder="$t('placeholder.select-date')" 
        )
    v-date-picker(
      no-title
      :max="max"
      :min="min"
      :value="value"
      style="width:100%;"
      @input="$emit('input', $event)"
      @change="visible = false"
    )
</template>
<script>
import TextFieldBase from './TextfieldBase.vue'
import { dateFormatDisplay } from '@/plugins/time'
export default {
  components: {
    TextFieldBase
  },
  props: {
    value: {
      type: [String,Object, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    min: {
      type: String,
      default: null
    }
  },
  data: () => ({
    visible: false,
  }),
  computed: {
    textDisplay () {
      return dateFormatDisplay(this.value)
    }
  },
}
</script>